export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8692.e7a1df18.jpg";